<template>
  <div>
    <div>
      <div class="content-header container-fluid bg-white">
        <div class="row">
          <div class="col-sm-4">
            <h4><i class="ti-shopping-cart-full"> </i> 物料管理 | 分类设置</h4>
          </div>
        </div>
      </div>
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <el-button type="primary" @click="rowEdit(1)">新增根分类</el-button>
            <el-button type="success" @click="imp">Excel导入</el-button>
            <span class="permission-setting">
              <span class="permission-label">申请分类权限</span>
              <el-switch v-model="permission.enabled" :disabled="permission.loading" @change="permissionChange" />
              <el-button v-if="permission.enabled" type="warning" icon="el-icon-user" @click="permissionEdit">权限编辑</el-button>
              <span class="permission-tip">
                {{ permission.enabled ? '已开启：教师按分配分类申请' : '已关闭：所有教师可申请全部分类' }}
              </span>
            </span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="w-block" style="padding: 2px;">
            </div>
            <div class="w-block">
              <el-table :data="grid.ls" v-loading="grid.loading" row-key="ID" border :tree-props="{ children: 'CHILDREN' }"
                lazy :load="getList" :cell-style="{ padding: '0px' }" :row-style="gridRowStyle"
                :header-cell-style="{ borderBottom: 'solid 1px #ccc', backgroundColor: '#f5f5f5', textAlign: 'center', padding: '5px 0px' }">
                <el-table-column prop="FULL_NAME" label="分类全称" width="300" />
                <el-table-column prop="NAME" label="物品名称" width="200">
                  <template slot-scope="scope">
                    <span>{{ scope.row.NAME }}</span>
                    <span v-if="!scope.row.LEAF"> [{{ scope.row.CNT_SON }}]</span>
                  </template>
                </el-table-column>
                <el-table-column prop="STORAGE_NAME" label="所属仓库" width="100" align="center" />
                <el-table-column prop="SORT" label="排序" width="80" align="center" />
                <el-table-column prop="ID" label="ID" width="80" align="center" />
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-plus" @click="rowEdit(2, scope.row)">增加</el-button>
                    <el-button type="text" icon="el-icon-edit" @click="rowEdit(3, scope.row)">修改</el-button>
                    <el-button type="text" icon="el-icon-delete" @click="rowDel(scope.row)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <Edit ref="cat_edit" @on-saved="filter" />
    </div>
    <div>
      <IMP ref="cat_imp" @on-saved="filter" />
      <Permission ref="cat_permission" />
    </div>
  </div>
</template>

<script>
import Edit from "./edit";
import IMP from './imp'
import Permission from './permission'
export default {
  name: "index",
  components: { Edit, IMP, Permission },
  data() {
    return {
      grid: {
        ls: [],
        loading: false
      },
      permission: { enabled: false, loading: false }
    }
  },
  created() {
    this.getList();
    this.getPermission();
  },
  methods: {
    filter() {
      this.grid.ls = [];
      this.getList();
    },
    getList(tree, treeNode, resolve) {
      let self = this;
      this.grid.loading = true;
      this.whale.remote.getCollection({
        url: "/api/School/MAT/MCatApi/GetList",
        data: { PARENT_ID: tree == undefined ? 0 : tree.ID },
        completed: function (its) {
          its.forEach(o => { o.hasChildren = !o.LEAF })
          if (resolve != undefined) {
            resolve(its)
          }
          else
            self.grid.ls = its;
          self.grid.loading = false;
        }
      })
    },
    gridRowStyle(row) {
      let lay = row.row.LAYER;
      if (lay == 1) return { background: '#e7f3ff' }
      else if (lay == 2) return { background: '#fcfbed' }
      else return { background: '#f5f5f5' }
    },
    rowEdit(method, row) {
      this.$refs.cat_edit.init(method, row);
    },
    rowDel(r) {
      this.whale.delConfirm(() => {
        this.whale.remote.getResult({
          url: "/api/School/MAT/MCatApi/Delete",
          data: { ID: r.ID },
          completed: function () {
            location.reload()
          }
        })
      });
    },
    imp() {
      this.$refs.cat_imp.init();
    },
    getPermission() {
      this.permission.loading = true;
      this.whale.remote.getResult({
        url: "/api/School/MAT/MCatApi/GetApplyPermission",
        completed: response => { this.permission.enabled = !!response.DATA.ENABLED; },
        finally: () => { this.permission.loading = false; }
      });
    },
    permissionChange(enabled) {
      this.permission.loading = true;
      this.whale.remote.getResult({
        url: "/api/School/MAT/MCatApi/SetApplyPermission",
        data: { ENABLED: enabled },
        completed: () => {
          this.$message.success(enabled ? "分类申请权限已开启" : "分类申请权限已关闭");
          if (enabled) this.permissionEdit();
        },
        finally: () => { this.permission.loading = false; }
      });
    },
    permissionEdit() {
      this.$refs.cat_permission.init();
    }
  }
}
</script>

<style scoped>
.permission-setting {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  margin-left: 18px;
  padding-left: 18px;
  border-left: 1px solid #dcdfe6;
}
.permission-label {
  color: #303133;
  font-weight: 600;
}
.permission-tip {
  color: #909399;
  font-size: 13px;
}
</style>

